import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { CandidateProfileSchema } from "@applicant-reviewer/api";

export function useManagerCandidateProfile(candidateId: string) {
  return useQuery({
    queryKey: ["manager-candidate-profile", candidateId],
    queryFn: () => apiClient.get(`/manager-candidates/${candidateId}/profile`, CandidateProfileSchema),
    enabled: Boolean(candidateId),
  });
}
